import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, BehaviorSubject} from 'rxjs';
import {ConversationId} from '../libraries/conversation-id';
import {RequestExecutor} from '../libraries/request-executor';
import {Constants} from '../constants';
import {environment} from '../../../environments/environment';

@Injectable({
    providedIn: 'root',
    deps: [ConversationId]
})
export class ApiService extends RequestExecutor {
    /**
     * Subject for selected segment
     * @var {BehaviorSubject<string>}
     */
    private _selectedSegmentSubject = new BehaviorSubject('');

    /**
     * Selected segment
     * @var {Observable}
     */
    public selectedSegment = this._selectedSegmentSubject.asObservable();

    /**
     * Class constructor
     * @param _conversationId
     * @param _httpClient Local instance of HTTP Client
     */
    constructor(
        protected _conversationId: ConversationId,
        protected _httpClient: HttpClient
    ) {
        super(_conversationId, _httpClient);
    }

    /**
     * Sets the current request headers
     *
     * @param requestHeaders
     * @returns {ApiService}
     */
    public setRequestHeaders(requestHeaders?: object): ApiService {
        super.setRequestHeaders(requestHeaders || {});

        return this;
    }

    /**
     * Sets the current request body
     *
     * @param requestBody
     * @returns {ApiService}
     */
    public setRequestBody(requestBody?: object): ApiService {
        super.setRequestBody(requestBody || {});

        return this;
    }

    /**
     * Sets the current request params
     *
     * @param requestParams
     * @returns {ApiService}
     */
    public setRequestParams(requestParams?: object): ApiService {
        super.setRequestParams(requestParams || {});

        return this;
    }

    /**
     * Gets availability based on the selected experience ID
     *
     * @returns {Observable<object>}
     */
    public getAvailability(): Observable<object> {
        return this.executeRequest(
            Constants.REQUEST_TYPE_GET,
            `${environment.apiConfiguration.basePath}${environment.apiConfiguration.paths.calendar}`
        );
    }

    /**
     * Sets the selected segment
     * @param selectedSegment
     *
     * @returns {void}
     */
    public setSelectedSegment(selectedSegment: string): void {
        this._selectedSegmentSubject.next(selectedSegment);
    }
}
